import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appCurrencyCode'
})
export class CurrencyCodePipe implements PipeTransform {
  private readonly defaultDisplay = 'narrow';

  public transform(value: string, locale?: string): ReturnType<typeof getCurrencySymbol> {
    return getCurrencySymbol(value, this.defaultDisplay, locale);
  }
}
